import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const generateDisputeActivityLog = {
  name: "generateDisputeActivityLog" as const,
  input: z.object({ disputeId: z.string(), source: z.enum(disputeSource) }),
  output: z.object({
    success: z.boolean(),
    activityLog: z.string().optional(),
    error: z.string().optional(),
  }),
};
